import { ReportIcon } from 'src/components/ui-icons/sidebar';
import ReportActions from '../../report-actions/report-actions';
import { useNavigate } from 'react-router-dom';
import { useCallback, useEffect, useState, useRef } from 'react';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { filterConfigReportAction, filtersOpenReportAction, initialFilterReportAction, years } from './filterDataActions';
import { getReportActions } from 'src/modules/vpo/actions';
import FilterForPlanAction from '../../planAction/filterForPlanAction/FilterForPlanAction';
import { isEqual } from 'lodash';
import { IFilters } from '../../../types/typesVPO';
import { selectReportActions, selectReportActionsStatus } from 'src/modules/vpo/selectors/selectReportActions';
import { buildDataReportActions } from '../../../utils/data-table';
import Loading from 'src/components/Loading';
import { selectCurrentUser } from 'src/modules/users/selector';
import { selectModelData } from '../../../store/filtersData/selector';
import { fetchData } from '../../../store/filtersData/actions';
import { transformDataForFilters, transformDataForFiltersFactory } from '../../../utils/plan_actions/plan_actions';
import React from 'react';

function ReportCompletedActions() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => selectCurrentUser(state));
  const initialFiltersRef = useRef<IFilters | null>(null);

  //! начальное состояние фильтров
  const [filtersInitialized, setFiltersInitialized] = useState(false);
  const [currentFilters, setCurrentFilters] = useState<IFilters | null>(null);

 const FilterColumns = useAppSelector((state: any) => selectModelData(state, 'vpo-columns'))
    ?.slice()
    .sort((a, b) => a.SortNumber - b.SortNumber);
  const FilteGroup = useAppSelector((state: any) => selectModelData(state, 'vpo-groups'));
  const dataFilter = useAppSelector((state: any) => selectModelData(state, 'vpo-factories'));
  const dataSubdiv = useAppSelector((state: any) => selectModelData(state, 'vpo-departments'));

  const transformedColumns = React.useMemo(() => transformDataForFilters(FilterColumns), [FilterColumns]);
  const transformedroups = React.useMemo(() => transformDataForFilters(FilteGroup), [FilteGroup]);
  const transformedFactories = React.useMemo(() => transformDataForFiltersFactory(dataFilter), [dataFilter]);

  //! Если выбрана группа VOP (id = 3), берем отделы из vpo-columns поле departmentsVOP
  const transformedDepartments = React.useMemo(() => {
    const isVOPGroup = currentFilters?.groupReportPeriod?.selectedIds?.includes(3);

    if (isVOPGroup && FilterColumns && currentFilters?.columnReportAction?.selectedIds) {
      const selectedColumns = FilterColumns.filter((col: any) =>
        currentFilters.columnReportAction?.selectedIds.includes(col.id)
      );
      const departmentsVOP: any[] = [];
      selectedColumns.forEach((col: any) => {
        if (col.departmentsVOP && Array.isArray(col.departmentsVOP)) {
          col.departmentsVOP.forEach((dept: any) => {
            if (!departmentsVOP.find(d => d.id === dept.id)) {
              departmentsVOP.push(dept);
            }
          });
        }
      });

      return transformDataForFilters(departmentsVOP);
    }

    return transformDataForFilters(dataSubdiv);
  }, [dataSubdiv, FilterColumns, currentFilters?.groupReportPeriod?.selectedIds, currentFilters?.columnReportAction?.selectedIds]);

  //! Получаю группы
  useEffect(() => {
    dispatch(
      fetchData(
        'vpo-groups',
        {},
        {
          page: 1,
          pageSize: 100,
        }
      )
    );
  }, [dispatch]);

  //! получаю колонны один раз при монтировании
  useEffect(() => {
    dispatch(fetchData('vpo-columns', {}, { page: 1, pageSize: 100 }));
  }, [dispatch]);

  //! Загружаем заводы для группы пользователя ДО инициализации фильтров
  useEffect(() => {
    if (transformedroups.length > 0 && user?.infoVPO && !filtersInitialized) {
      let userGroupId: number | null = null;
      if (user.infoVPO.directoryTitle?.length > 0) {
        const userGroups = user.infoVPO.directoryTitle;
        const priorityOrder = ['BOP', 'VOP', 'SOP'];
        const priorityTitle = priorityOrder.find((p) => userGroups.includes(p)) || userGroups[0];
        const userGroup = transformedroups.find((g: any) => g.Title === priorityTitle);
        userGroupId = userGroup?.ID || transformedroups[0]?.ID;
      } else if (transformedroups[0]) {
        userGroupId = transformedroups[0].ID;
      }

      if (userGroupId) {
        dispatch(fetchData('vpo-factories', { group: [userGroupId] }, { page: 1, pageSize: 100 }));
      }
    }
  }, [transformedroups, user?.infoVPO, filtersInitialized, dispatch]);

  //! При изменении группы получаю заводы
  useEffect(() => {
    if (filtersInitialized && currentFilters?.groupReportPeriod?.selectedIds) {
      dispatch(fetchData('vpo-factories', { group: currentFilters?.groupReportPeriod?.selectedIds }, { page: 1, pageSize: 100 }));
    }
  }, [filtersInitialized, currentFilters?.groupReportPeriod?.selectedIds, dispatch]);

  //! При изменении завода и колонны получаю подразделение
  useEffect(() => {
    const isVOPGroup = currentFilters?.groupReportPeriod?.selectedIds?.includes(3);
    if (filtersInitialized && currentFilters?.factoryReport?.selectedIds && currentFilters?.columnReportAction?.selectedIds && !isVOPGroup) {
      dispatch(
        fetchData(
          'vpo-departments',
          {
            factories: currentFilters?.factoryReport?.selectedIds,
            columns: currentFilters?.columnReportAction?.selectedIds,
          },
          {
            page: 1,
            pageSize: 100,
          }
        )
      );
    }
  }, [filtersInitialized, currentFilters?.factoryReport?.selectedIds, currentFilters?.columnReportAction?.selectedIds, currentFilters?.groupReportPeriod?.selectedIds, dispatch]);

  const dataReportActions = useAppSelector(selectReportActions);
  const statusReportActions = useAppSelector(selectReportActionsStatus);

  if (dataReportActions) console.log('dataReportActions', dataReportActions);

  const getDefaultGroup = useCallback(() => {
    if (!user?.infoVPO || transformedroups.length === 0) {
      return null;
    }

    if (user.infoVPO.directoryTitle?.length > 0) {
      const userGroupTitles = user.infoVPO.directoryTitle;
      for (const groupTitle of userGroupTitles) {
        const exactMatch = transformedroups.find((group) => group.Title === groupTitle);
        if (exactMatch) {
          return exactMatch;
        }
      }

      for (const groupTitle of userGroupTitles) {
        const partialMatches = transformedroups.filter((group) => group.Title.includes(groupTitle) || groupTitle.includes(group.Title));
        if (partialMatches.length > 0) {
          return partialMatches[0];
        }
      }
    }

    if (user.infoVPO.factory?.length > 0) {
      const userFactoryIds = user.infoVPO.factory.map((f: { factoryID: number }) => f.factoryID);
      const userFactoryTitles = user.infoVPO.factory.map((f: { factoryTitle: string }) => f.factoryTitle);

      for (const group of transformedroups) {
        if (group.Factory && group.Factory.some((f: any) => userFactoryIds.includes(f.ID) || userFactoryTitles.includes(f.Title))) {
          return group;
        }
      }
    }
    if (user.infoVPO.adminRegion && transformedroups.length > 0) {
      return transformedroups[0];
    }
    if (transformedroups.length > 0) {
      return transformedroups[0];
    }
    return null;
  }, [user?.infoVPO, transformedroups]);

  //! начальное состояние фильтров
  useEffect(() => {
    if (user?.infoVPO && transformedroups.length > 0 && transformedColumns.length > 0 && transformedFactories.length > 0 && !filtersInitialized) {
      const defaultGroup = getDefaultGroup();

      if (defaultGroup) {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();

        const sortedColumns = [...transformedColumns].sort((a, b) => a.Title.localeCompare(b.Title, 'ru'));
        const firstColumn = sortedColumns[0];

        let defaultFactory: { ID: number; Title: string } | null = null;
        const userFactoryIds = Array.isArray(user.infoVPO.factory)
          ? user.infoVPO.factory.map((f: { factoryID: number }) => f.factoryID)
          : user.infoVPO.factory?.factoryID
          ? [user.infoVPO.factory.factoryID]
          : [];

        const factoriesInGroup = transformedFactories.filter((factory: any) => factory.VPOgroup && factory.VPOgroup.id === defaultGroup.ID);

        const availableFactories = factoriesInGroup.filter((factory: any) => userFactoryIds.includes(factory.ID));

        if (availableFactories.length > 0) {
          const sortedFactories = [...availableFactories].sort((a, b) => a.Title.localeCompare(b.Title));
          defaultFactory = sortedFactories[0];
        }

        const newInitialFilters = {
          year: {
            selected: [currentYear.toString()],
            selectedIds: [currentYear],
            search: '',
          },
          columnReportAction: {
            selected: [firstColumn.Title],
            selectedIds: [firstColumn.ID],
            search: '',
          },
          factoryReport: defaultFactory
            ? { selected: [defaultFactory.Title], selectedIds: [defaultFactory.ID], search: '' }
            : { selected: ['Владивосток'], selectedIds: [2], search: '' },
          groupReportPeriod: defaultGroup
            ? { selected: [defaultGroup.Title], selectedIds: [defaultGroup.ID], search: '' }
            : { selected: ['BOP'], selectedIds: [3], search: '' },
          department: {
            selected: [],
            selectedIds: [],
            search: '',
          },
        };

        initialFiltersRef.current = { ...newInitialFilters };
        setCurrentFilters({ ...newInitialFilters });
        setFiltersInitialized(true);

        dispatch(getReportActions(newInitialFilters));
      } else {
        const fallbackFilters = JSON.parse(JSON.stringify(initialFilterReportAction));
        initialFiltersRef.current = fallbackFilters;
        setCurrentFilters(fallbackFilters);
        setFiltersInitialized(true);

        dispatch(getReportActions(fallbackFilters));
      }
    }
  }, [user?.infoVPO, transformedroups, transformedColumns, transformedFactories, getDefaultGroup, dispatch, filtersInitialized]);

  //! года в фильтре показываются динамически см в файле filterDataActions.ts
  const filterConfigs = {
    year: { items: years },
    columnReportAction: { items: transformedColumns },
    factoryReport: { items: transformedFactories },
    groupReportPeriod: { items: transformedroups },
    department: { items: transformedDepartments },
  };

  const filtersMap = {
    year: years,
    columnReportAction: transformedColumns,
    factoryReport: transformedFactories,
    groupReportPeriod: transformedroups,
    department: transformedDepartments,
  };

  //! обновление фильтров в начальном состоянии
  const handleFiltersChange = useCallback(
    (newFilters: React.SetStateAction<IFilters | null>) => {
      if (!isEqual(currentFilters, newFilters)) {
        //! в консоли можешь посмотреть
        console.log('Новые фильтры ОТЧЕТЫ:', newFilters);
        dispatch(getReportActions(newFilters));
        setCurrentFilters(newFilters);
      }
    },
    [currentFilters, dispatch]
  );

  return (
    <div className='flex justify-between w-full h-full'>
      <div className='w-[320px] mr-2 bg-white'>
        <FilterForPlanAction
          key={`filter-${initialFiltersRef.current?.groupReportPeriod?.selectedIds?.[0] || 'default'}`}
          onFiltersChange={handleFiltersChange}
          filterConfigs={filterConfigs}
          filtersMap={filtersMap}
          initialFilters={initialFiltersRef.current || initialFilterReportAction}
          filtersOpen={filtersOpenReportAction}
          filtersConfig={filterConfigReportAction}
          responsibleFil={false}
          selectedGropu={true}
          heightFilter={'max-h-screen'}
        />
      </div>
      <div className='flex-1 min-w-0 m-6'>
        <div className='flex items-center text-gray-600 mb-6'>
          <span className='pr-3'>
            <ReportIcon />
          </span>
          <span className='cursor-pointer text-base' onClick={() => navigate('/dashboard/6/reports')}>
            Отчеты
          </span>
          <span className='mx-2'>→</span>
          <span className='text-base'>Отчет по выполненным действиям</span>
        </div>
        <div className='min-w-0'>
          {statusReportActions === 'LOADING' && <Loading />}
          {statusReportActions === 'SUCCESS' && dataReportActions && <ReportActions key={`report-${currentFilters?.year?.selectedIds?.[0]}`} data={buildDataReportActions(dataReportActions.data)} selectedYear={currentFilters?.year?.selectedIds?.[0] || new Date().getFullYear()} />}
          {statusReportActions === 'IDLE' && <Loading />}
        </div>
      </div>
    </div>
  );
}

export default ReportCompletedActions;
